import ReactDOM from 'react-dom';

// Polyfill for findDOMNode compatibility with React 19
export const initializeQuillPolyfill = () => {
  if (!ReactDOM.findDOMNode) {
    ReactDOM.findDOMNode = (node) => {
      if (node == null) {
        return null;
      }
      if (node.nodeType === 1) {
        return node;
      }

      // For React components, try to access the DOM element
      if (node._reactInternalFiber || node._reactInternalInstance) {
        const fiber = node._reactInternalFiber || node._reactInternalInstance;
        let current = fiber;

        // Walk up the fiber tree to find a DOM node
        while (current) {
          if (current.stateNode && current.stateNode.nodeType === 1) {
            return current.stateNode;
          }
          current = current.child;
        }
      }

      // Last resort: if it's a ref object with current property
      if (node.current && node.current.nodeType === 1) {
        return node.current;
      }

      console.warn('findDOMNode is deprecated and may not work correctly with React 19');
      return null;
    };
  }
};
